import { motion } from "framer-motion";
import {
  BadgeCheck,
  Briefcase,
  Camera,
  Flame,
  Gamepad2,
  PackageCheck,
  Rocket,
  ShieldCheck,
} from "lucide-react";
import { useLang } from "../LanguageContext";

const OPPORTUNITY_ICONS = {
  create: Camera,
  grow: Rocket,
  professional: Briefcase,
  experience: Flame,
};

const CONFIDENCE_ICONS = {
  beginner: Gamepad2,
  equipment: PackageCheck,
  safety: ShieldCheck,
  rules: BadgeCheck,
};

export const Opportunities = () => {
  const { t } = useLang();

  return (
    <section id="oferta" className="bg-[#0A0A0A] py-20 sm:py-28">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-3xl mb-12 sm:mb-16">
          <p className="font-body text-xs font-bold uppercase tracking-[0.22em] text-[#E02020] mb-4">
            {t.opportunities.overline}
          </p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white">
            {t.opportunities.title}
          </h2>
          <p className="mt-5 text-[#A3A3A3] text-base sm:text-lg leading-relaxed max-w-2xl">
            {t.opportunities.intro}
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 border-l border-t border-white/10">
          {t.opportunities.cards.map((card, index) => {
            const Icon = OPPORTUNITY_ICONS[card.id] || Camera;
            return (
              <motion.article
                key={card.id}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, ease: "easeOut", delay: index * 0.08 }}
                className="group min-h-[290px] bg-[#111111] border-r border-b border-white/10 p-6 sm:p-7 flex flex-col hover:bg-[#171717] transition-colors"
              >
                <Icon className="text-[#E02020] mb-10" size={34} strokeWidth={1.6} />
                <div className="mt-auto">
                  <p className="font-display text-xs font-bold tracking-[0.18em] text-white/45 mb-3">
                    {card.title}
                  </p>
                  <p className="text-white/90 leading-relaxed">{card.text}</p>
                </div>
              </motion.article>
            );
          })}
        </div>

        <div className="mt-16 sm:mt-20 border border-white/10 bg-[#111111] p-6 sm:p-10">
          <div className="max-w-2xl mb-8">
            <p className="font-body text-xs font-bold uppercase tracking-[0.22em] text-[#E02020] mb-3">
              {t.confidence.overline}
            </p>
            <h3 className="font-display text-2xl sm:text-3xl font-semibold tracking-tight text-white">
              {t.confidence.title}
            </h3>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-8">
            {t.confidence.items.map((item) => {
              const Icon = CONFIDENCE_ICONS[item.id] || BadgeCheck;
              return (
                <div key={item.id} className="flex items-start gap-3">
                  <Icon className="text-[#E02020] shrink-0 mt-0.5" size={21} />
                  <div>
                    <h4 className="font-display font-semibold text-white mb-1">{item.title}</h4>
                    <p className="text-sm text-[#A3A3A3] leading-relaxed">{item.text}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
